import { render, staticRenderFns } from "./userAdministration.vue?vue&type=template&id=5174ef9c&"
import script from "./userAdministration.vue?vue&type=script&lang=js&"
export * from "./userAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports